module.exports = __webpack_public_path__ + "img/zaluzie-priprava.d143f305.svg";